import { z, infer as ZodInfer } from "zod"
import { projectExtendedSchema } from "./projects"
import { tagExtendedSchema } from "./tag"
import { SupportedRegions, DistanceUnit } from "@nova/constants"
import { locationSchema } from "../util"

export type TagTree = {
    [folderTagId: string]: TagTree | undefined
}

export const tagTreeSchema: z.ZodType<TagTree> = z.record(
    z.string(),
    z.lazy(() => tagTreeSchema)
)

export const organizationSettingsSchema = z.array(
    z.object({
        name: z.string(),
        value: z.union([z.string(), z.boolean(), z.number()]),
    })
)

export const organizationBasicSchema = z.object({
    id: z.string(),
    name: z.string(),
    settings: organizationSettingsSchema,
    region: z.enum(SupportedRegions),
    distanceUnit: z.enum(DistanceUnit),
    tagTree: tagTreeSchema,
})

export const organizationRecordSchema = z.object({
    id: z.string(),
    sk: z.string(),
    fullName: z.string().catch("Unnamed Workspace"),
    projectIds: z.array(z.string()).catch([]),
    settings: organizationSettingsSchema.catch([]),
    tagTree: tagTreeSchema.catch({}),
    location: locationSchema.optional(),
    createdAt: z.string().optional(),
    createdBy: z.string().optional(),
    updatedAt: z.string().optional(),
    updatedBy: z.string().optional(),
})

export const organizationExtendedSchema = z.object({
    id: z.string(),
    region: z.enum(SupportedRegions),
    name: z.string(),
    location: locationSchema.optional(),
    rootLevelProjects: z.array(projectExtendedSchema),
    tags: z.array(tagExtendedSchema),
    settings: organizationSettingsSchema,
    distanceUnit: z.enum(DistanceUnit),
    tagTree: tagTreeSchema,
})

export type OrganizationSettings = ZodInfer<typeof organizationSettingsSchema>

export type OrganizationRecord = ZodInfer<typeof organizationRecordSchema>

export type OrganizationBasic = ZodInfer<typeof organizationBasicSchema>

export type OrganizationExtended = ZodInfer<typeof organizationExtendedSchema>

export type Location = ZodInfer<typeof locationSchema>
